<span class="guideline-icon">
    <app-guideline-status-icon [processing]="playbookRunning" [status]="guideline?.status" class="guideline-icon"></app-guideline-status-icon>
</span>
<div class="timeline-event">
    <div class="d-flex justify-content-between flex-sm-row columngap mb-sm-0 mb-1">
        <div class="font-small-3">
            {{guideline?.content}}
        </div>
    </div>
</div>